import { component } from 'picoapp';

export default component(async (node) => {
  const scroll = node.querySelector('[data-scroll]');

  if (scroll) {
    scroll.addEventListener('click', (e) => {
      e.preventDefault();

      window.scrollTo({
        top: node.offsetTop + node.offsetHeight,
        behavior: 'smooth',
      });
    });
  }
});
